(() => {
  const gate = document.querySelector('[data-bay-gate]');
  if (!gate) return;

  const storageKey = 'bay-or-bust-access-v1';
  const pendingKey = 'bay-or-bust-access-pending-v1';
  const form = gate.querySelector('form');
  const email = gate.querySelector('#BayGateEmail');
  const zip = gate.querySelector('#BayGateZip');
  const tags = gate.querySelector('[data-gate-tags]');
  const submit = gate.querySelector('.bay-gate__submit');
  const status = gate.querySelector('.bay-gate__status');
  const countyLabel = gate.querySelector('.bay-gate__county');
  const metaLabel = gate.querySelector('.bay-gate__meta');
  const mapbox = gate.querySelector('.bay-gate__mapbox');
  const svgElement = gate.querySelector('.bay-gate__map');

  const grantAccess = () => {
    try { window.localStorage.setItem(storageKey, 'granted'); } catch (_) {}
    document.cookie = 'bay_or_bust_access=granted; path=/; max-age=31536000; SameSite=Lax';
  };

  const counties = {
    '06001': { name: 'Alameda', zips: '94501-94502,94536-94546,94550-94552,94555,94557,94560,94566,94568,94577-94580,94586-94588,94601-94666,94701-94720' },
    '06013': { name: 'Contra Costa', zips: '94505-94507,94509,94511,94513-94514,94516-94531,94547-94549,94553,94556,94561,94563-94565,94569-94570,94572,94575,94582-94583,94595-94598,94801-94820,94850' },
    '06041': { name: 'Marin', zips: '94901,94903-94904,94912-94915,94920,94924-94925,94929-94930,94933,94937-94942,94945-94950,94956-94957,94960,94963-94966,94970-94971,94973-94979,94998' },
    '06055': { name: 'Napa', zips: '94503,94508,94515,94558-94559,94562,94567,94573-94574,94576,94581,94599' },
    '06075': { name: 'San Francisco', zips: '94102-94199' },
    '06081': { name: 'San Mateo', zips: '94002,94005,94010-94011,94014-94021,94025-94030,94037-94038,94044,94060-94066,94070,94074,94080-94083,94401-94404,94497' },
    '06085': { name: 'Santa Clara', zips: '94022-94024,94035,94039-94043,94085-94089,94301-94310,95002,95008-95015,95020-95021,95026,95030-95038,95042,95044,95046,95050-95056,95070-95071,95101-95199' },
    '06095': { name: 'Solano', zips: '94510,94512,94533-94535,94571,94585,94589-94592,95620,95625,95687-95688,95690,95696' },
    '06097': { name: 'Sonoma', zips: '94922-94923,94926-94928,94931,94951-94955,94972,94975,94999,95401-95407,95409,95412,95416,95419,95421,95425,95430-95431,95433,95436,95439,95441-95442,95444,95446,95448,95450,95452,95462,95465,95471-95473,95476,95480,95486-95487,95492,95497' },
  };

  const zipMap = new Map();
  Object.entries(counties).forEach(([fips, county]) => {
    county.zips.split(',').forEach((token) => {
      const [start, end] = token.split('-').map(Number);
      for (let value = start; value <= (end ?? start); value += 1) zipMap.set(value, fips);
    });
  });

  const frameText = () => {
    const horizontal = Math.ceil(window.innerWidth / 5.5);
    const vertical = Math.ceil(window.innerHeight / 5.5);
    gate.querySelector('.bay-gate__frame-top').textContent = '10'.repeat(horizontal);
    gate.querySelector('.bay-gate__frame-left').textContent = '10'.repeat(vertical);
    gate.querySelector('.bay-gate__frame-right').textContent = '10'.repeat(vertical);
  };
  frameText();
  window.addEventListener('resize', frameText);

  const showGranted = (details) => {
    countyLabel.textContent = `${details.county} County`;
    metaLabel.textContent = `${details.zip} · ${details.email}`;
    gate.classList.add('is-granted');
    window.setTimeout(() => {
      grantAccess();
      document.documentElement.classList.remove('bay-gate-locked');
      gate.remove();
    }, 2600);
  };

  if (gate.querySelector('[data-gate-succeeded]')) {
    let pending;
    try { pending = JSON.parse(window.sessionStorage.getItem(pendingKey)); } catch (_) {}
    try { window.sessionStorage.removeItem(pendingKey); } catch (_) {}
    const url = new URL(window.location.href);
    url.searchParams.delete('gate_submitted');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    if (pending?.county && pending?.zip && pending?.email) showGranted(pending);
    else {
      grantAccess();
      document.documentElement.classList.remove('bay-gate-locked');
      gate.remove();
    }
    return;
  }

  let unlocked = false;
  try { unlocked = window.localStorage.getItem(storageKey) === 'granted'; } catch (_) {}
  unlocked = unlocked || document.cookie.split('; ').includes('bay_or_bust_access=granted');
  if (unlocked) {
    document.documentElement.classList.remove('bay-gate-locked');
    gate.remove();
    return;
  }

  document.documentElement.classList.add('bay-gate-locked');
  window.requestAnimationFrame(() => email.focus({ preventScroll: true }));

  let currentCounty = null;
  const validEmail = (value) => /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(value.trim());
  const sync = () => { submit.disabled = !(currentCounty && validEmail(email.value)); };
  const shake = (element) => {
    element.classList.remove('bay-gate__shake');
    void element.offsetWidth;
    element.classList.add('bay-gate__shake');
  };

  zip.addEventListener('input', () => {
    const raw = zip.value.replace(/\D/g, '').slice(0, 5);
    if (zip.value !== raw) zip.value = raw;
    const fips = raw.length === 5 ? zipMap.get(Number(raw)) : null;
    currentCounty = fips ? counties[fips] : null;
    status.classList.toggle('is-bust', !currentCounty && raw.length === 5);
    if (currentCounty) status.textContent = `That's Bay · ${currentCounty.name} County`;
    else {
      status.textContent = raw.length === 5 ? "You're A Bust" : '';
      if (raw.length === 5) shake(zip);
    }
    sync();
  });
  email.addEventListener('input', sync);

  form.addEventListener('submit', (event) => {
    if (!currentCounty || !validEmail(email.value)) {
      event.preventDefault();
      if (!currentCounty) {
        status.classList.add('is-bust');
        status.textContent = "You're A Bust";
      }
      shake(form);
      return;
    }
    const details = { county: currentCounty.name, zip: zip.value, email: email.value.trim() };
    tags.value = `newsletter,access-gate,zip-${details.zip},county-${details.county.toLowerCase().replace(/\s+/g, '-')}`;
    try { window.sessionStorage.setItem(pendingKey, JSON.stringify(details)); } catch (_) {}
    grantAccess();
    submit.disabled = true;
  });

  const places = [
    ['San Francisco', -122.4194, 37.7749, 'end', -7, 3, true],
    ['Oakland', -122.2712, 37.8044, 'start', 7, -3, true],
    ['San Jose', -121.8863, 37.3382, 'start', 7, 3, true],
    ['Santa Rosa', -122.7141, 38.4404, 'end', -7, 3, false],
    ['Palo Alto', -122.1430, 37.4419, 'end', -7, 3, false],
  ];

  const drawMap = async () => {
    if (!window.d3 || !window.topojson) return;
    let topology;
    try { topology = await fetch(gate.dataset.countiesUrl).then((response) => response.json()); }
    catch (_) { return; }
    const geometries = topology.objects.counties.geometries.filter((geometry) => counties[geometry.id]);
    const features = window.topojson.feature(topology, topology.objects.counties).features.filter((feature) => counties[feature.id]);
    const outline = window.topojson.merge(topology, geometries);
    const inner = window.topojson.mesh(topology, { type: 'GeometryCollection', geometries }, (a, b) => a !== b);
    const collection = { type: 'FeatureCollection', features };
    const svg = window.d3.select(svgElement);

    const render = () => {
      const width = mapbox.clientWidth;
      const height = mapbox.clientHeight;
      if (!width || !height) return;
      svg.attr('viewBox', `0 0 ${width} ${height}`).selectAll('*').remove();
      const projection = window.d3.geoMercator().fitExtent([[26, 10], [width - 26, height - 10]], collection);
      const path = window.d3.geoPath(projection);
      svg.append('path').attr('class', 'bay-gate__glow').attr('d', path(outline));
      svg.append('path').attr('class', 'bay-gate__region').attr('d', path(outline));
      svg.append('path').attr('class', 'bay-gate__inner').attr('d', path(inner));
      const group = svg.append('g');
      places.forEach(([name, longitude, latitude, anchor, dx, dy, key]) => {
        const point = projection([longitude, latitude]);
        if (!point) return;
        group.append('circle').attr('class', 'bay-gate__place-dot').attr('cx', point[0]).attr('cy', point[1]).attr('r', 1.6);
        group.append('text').attr('class', `bay-gate__place${key ? ' bay-gate__place--key' : ''}`).attr('x', point[0] + dx).attr('y', point[1] + dy).attr('text-anchor', anchor).text(name);
      });
    };

    render();
    let timer;
    window.addEventListener('resize', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(render, 180);
    });
  };
  drawMap();
})();
